<template>
    <div class='component-page'>
       
        <!--下拉搜索位置-->
        <div class="edittable-table-height-con">
            <Row class='search-select'>
                <Col span="8">
                    <span>时间：</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='start_time' style="width: 130px;display:inline-block" @on-change='changStarttime'></Date-picker>
                    <span style="margin: 0 10px;">至</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='end_time' style="width: 130px;display:inline-block" @on-change='changEndtime'></Date-picker>
                </Col>
                <Col span="6">
                    <Select v-model="formItem.user_id" placeholder="学生" @on-change="handleSearch" clearable style="width:200px">
                        <Option v-for="item in userList" :value="item.user_id" :key="item.user_id">{{ item.nickname }}</Option>
                    </Select>
                </Col>
            </Row>
            <Table stripe border :columns="editIncellColumns" :data="editIncellData"></Table>
            <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
                <Page style='float: right'  size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
            </div>
        </div>
         <!--提醒弹层-->
        <Modal v-model="remindModal" width="440" class='remind'>
            <div class='remindContent'>
                {{remindContent}}
            </div>
            <div slot="footer">
                <Button type='primary' ghost shape="circle" @click='cancelRemain'>取消</Button>
                <Button type="primary" shape="circle" @click="primaryRemind">确定</Button>
            </div>
        </Modal>
        <Modal v-model="videoModal" width="440" on-cancel='cancelVideo'>
            <video v-if='videoModal' :src='videoUrl' controls="controls" autoplay="autoplay" style='margin:0 auto;width:60%;display:block'>
                <source :src='videoUrl' type="video/mp4">
                <source :src='videoUrl' type="video/mov">
            </video>
            <div slot="footer">
                <Button type='primary' ghost shape="circle" @click='cancelVideo'>关闭</Button>
            </div>
        </Modal>
    </div>
</template>

<style lang="css">
    @import "../common.css";
</style>
<script>
    import {
        fetchTableList,
        setStatus,
        fetchUserList
    } from '@/api/studentVideo'

    export default {
        name: 'user-components',
        data () {
            return {
                total_count: 0, //列表总条数
                formItem:{
                    page: 1, //列表当前页数
                    page_size: 10,
                    start_time: '',
                    end_time: '',
                    user_id:'',
                },
                videoUrl:'',
                videoModal:false,
                start_time: '',
                end_time: '',
                userList:[],
                remindContent:'',//提醒内容
                remindModal:false,//提醒弹层状态
                editIncellColumns: [
                    {
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                    },
                    
                    {
                        title: '昵称',
                        align: 'center',
                        key: 'nickname',
                    },
                    {
                        title: '真实姓名',
                        align: 'center',
                        key: 'realname',
                    },
                    {
                        title: '校区名称',
                        align: 'center',
                        key: 'school_name',
                    },
                    {
                        title: '班级名称',
                        align: 'center',
                        key: 'class_name',
                    },
                    {
                        title: '章节名称',
                        align: 'center',
                        key: 'chapter_name',
                    },
                    {
                        title: '视频',
                        align: 'center',
                        key: 'video_url',
                        width: 100,
                        render: (h, params) => {
                            return h("video", {
                                attrs: {
                                    src: params.row.video_url
                                },
                                style: {
                                    width: '60px',
                                    height: '60px',
                                    marginTop: '4px'
                                },
                                on: {
                                    click: () => {
                                        this.seeVideo(params.row.video_url)
                                    }
                                }
                            })
    
                        }
                    },
                    {
                        title: '审核状态',
                        align: 'center',
                        key: 'status',
                        render: (h, params) => {
                            if(params.row.status==1){
                                return h('div', '审核通过')
                            }else if(params.row.status==0){
                                return h('div', '未审核')
                            }else{
                                return h('div', '审核拒绝')

                            }
                        }
                    },
                    {
                        title: '创建时间',
                        align: 'center',
                        key: 'create_at',
                        width:150,

                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'action',
                        width: 120,
                        render: (h, params) => {
                            if(params.row.status==0){
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.changeStatus(params.row.homework_id,'1','确定通过该视频吗？')
                                            }
                                        }
                                    }, '通过'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small',
                                            ghost: true
                                        },
                                       
                                        on: {
                                            click: () => {
                                                this.changeStatus(params.row.homework_id,'2','确定拒绝该视频吗？')
                                            }
                                        }
                                    }, '拒绝'),
                                ])
                            }else if(params.row.status==1){
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small',
                                            ghost: true
                                        },
                                       
                                        on: {
                                            click: () => {
                                                this.changeStatus(params.row.homework_id,'2','确定拒绝该视频吗？')
                                            }
                                        }
                                    }, '拒绝'),
                                ])
                            }else{
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.changeStatus(params.row.homework_id,'1','确定通过该视频吗？')
                                            }
                                        }
                                    }, '通过'),
                                   
                                ])
                            }
                           
                        }
                    }
                
                ],//列表
                editIncellData: [],//列表数据
            };
        },
        methods: {
            //获取列表数据
            getData () {
                this.$Loading.start();
                fetchTableList(this.formItem).then(res => {
                    res=res.data;
                    this.$Loading.finish();
                    if(res.code == 200){
                        this.editIncellData = res.data.list;
                        this.total_count = parseInt(res.data.total_count);
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
            getUserList(){
                fetchUserList().then(res => {
                    res=res.data;
                    this.$Loading.finish();
                    if(res.code == 200){
                        this.userList = res.data;
                       
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            }, 
            seeVideo(url){
                this.videoUrl=url;
                this.videoModal=true;
            }, 
            // 改变状态
            changeStatus(id,status,info){
                this.homework_id = id;
                this.status=status;
                this.remindContent = info;
                this.remindModal = true; 
            },
            //提醒弹出层的确定事件
            primaryRemind(){
                    setStatus({
                        homework_id:this.homework_id,
                        status:this.status
                    }).then(res => {
                        res=res.data;
                        if(res.code==200){
                            this.getData();
                            this.remindModal=false;
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })
                
                
            },
             // 改变开始时间
            changStarttime(time) {
                if (time == '') {
                    this.formItem.start_time = '';
                } else {
                    this.formItem.start_time = new Date(time).getTime() / 1000 - 28800;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 改变结束时间
            changEndtime(time) {
                if (time == '') {
                    this.formItem.end_time = '';
                } else {
                    this.formItem.end_time = new Date(time).getTime() / 1000 + 57600;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 取消关闭弹层
            cancel(){
                this.addModel=false;
                this.detailsModal=false;
            },
            // 关闭提醒弹出
            cancelRemain(){
                this.remindModal = false; 
            },
            //搜索框搜索
            handleSearch () {
                this.formItem.page = 1;
                this.getData();
            },
            //改变当前页码
            changePage (row) {
                this.formItem.page = row;
                this.getData();
            },
            cancelVideo(){
                this.videoModal = false; 
            },
            
        },
        created () {
            this.getData();
            this.getUserList();
        }
    };
</script>
